module.exports = __webpack_public_path__ + "static/media/icon-quizz.45ae44c1.svg";